import styled from "styled-components";

import { breakpoints } from "@/styles/breakpoints";

export const StyledTipBoxContainer = styled.div`
    box-sizing: border-box;
    display: flex;
    width: 100%;
    height: 68px;
    border: 1px solid var(--color-grey-700);
    border-radius: var(--radius-5);

    .light-bulb-container {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 15%;
        height: 100%;
    }

    .tip-box {
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 85%;

        .tip {
            margin: 0;
            font-size: var(--size-16);
            font-weight: bold;
            line-height: 22px;
            color: var(--color-primary);
            text-align: left;
            @media ${breakpoints.xs} {
                font-size: var(--size-14);
            }
        }

        .inbox-search {
            margin: 0;
            font-size: var(--size-16);
            font-style: normal;
            font-weight: normal;
            line-height: 22px;
            color: var(--color-grey-800);
            text-align: left;
            @media ${breakpoints.xs} {
                font-size: var(--size-14);
            }
        }
    }
`;

export const StyledFindEmail = styled.p`
    width: 100%;
    font-size: var(--size-16);
    font-style: normal;
    font-weight: bold;
    line-height: 22px;
    color: var(--color-grey-800);
    text-align: center;
    background-color: transparent;
    border: none;
`;
